var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkasoutofstock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.90039,
    y: 3.89941,
    width: 16.2,
    height: 16.2,
    rx: 3,
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76172 9.18941V3.89941H15.2417V9.18941C15.2417 10.0135 14.301 10.4838 13.6417 9.98941L12.6017 9.20941C12.2462 8.94275 11.7573 8.94275 11.4017 9.20941L10.3617 9.98941C9.70248 10.4838 8.76172 10.0135 8.76172 9.18941Z",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3L3 21",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkasoutofstock);
export default __webpack_public_path__ + "static/media/Mark as out of stock.4af3a9878eade0a7dd4e459eeece029a.svg";
export { ForwardRef as ReactComponent };